import api from '../api'
import convertLang from '../../../utils/convertLang'

const qs = require('qs')

const apiRoute = '/legals'

export const getPageBySlug = async (locale, slug) => {
  const query = qs.stringify(
    {
      locale: convertLang.convertLang(locale),
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: {
        page: {
          populate: ['hero', 'hero.image_mobile', 'hero.image_tablet', 'hero.image_desktop', 'items', 'banner'],
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  )
  try {
    const response = await api.get(`${apiRoute}?${query}`)
    if (response.data.data && response.data.data[0]['page']) {
      return response.data.data[0]['page']
    }

    return []
  } catch {
    return []
  }
}

export default {
  getPageBySlug,
}
